import React, {
  useState,
  Children,
} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  withStyles,
  ListItem,
  Icon,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Collapse,
  List,
  Popper,
  Paper,
  ClickAwayListener,
} from '@material-ui/core';
import {
  ExpandLess,
  ExpandMore,
} from '@material-ui/icons';
import styles from './styles';

export const NavSectionComponent = ({
  label,
  classes,
  icon,
  children,
  drawerOpen,
  location,
}) => {
  const [open, setOpen] = useState(false);
  const [popperAnchorElement, setPopperAnchorElement] = useState(null);

  const sectionRoutes = [];

  const childrenWithProps = Children.map(children, (child) => {
    if (child && child.props && child.props.route) {
      sectionRoutes.push(child.props.route);
    }

    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        containedInSection: true,
        expandNavSection: () => setOpen(true),
        collapseNavSection: () => {
          if (!drawerOpen) {
            setOpen(false);
          }
        },
      });
    }
    return child;
  });

  const onCurrentPage = sectionRoutes.indexOf(location.pathname) > -1;

  const handleClick = (event) => {
    setPopperAnchorElement(event.currentTarget);
    setOpen(!open);
  };
  const handleClickAway = () => {
    if (!drawerOpen) {
      setOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={
          onCurrentPage
            ? classes.highlightContainer
            : {}
        }
      >
        <ListItem
          button
          className={
            onCurrentPage
              ? classes.highlight
              : classes.listItem
          }
          onClick={handleClick}
        >
          {
            icon
              && (
                <Tooltip title={label} placement="right">
                  <ListItemIcon
                    className={
                      onCurrentPage
                        ? classes.listItemIconHighlight
                        : classes.listItemIcon
                      }
                  >
                    <Icon>
                      {icon}
                    </Icon>
                  </ListItemIcon>
                </Tooltip>
              )
          }
          <ListItemText primary={label} />
          {
            open
              ? <ExpandLess />
              : <ExpandMore />
          }
        </ListItem>
        {
          drawerOpen
            ? (
              <Collapse in={open} timeout="auto">
                <List component="div" disablePadding>
                  {childrenWithProps}
                </List>
              </Collapse>
            )
            : (
              <Popper className={classes.popper} anchorEl={popperAnchorElement} open={open} placement="right">
                <Paper>
                  {childrenWithProps}
                </Paper>
              </Popper>
            )
        }
      </div>
    </ClickAwayListener>
  );
};

NavSectionComponent.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  icon: PropTypes.string,
  classes: PropTypes.object,
  children: PropTypes.any,
  drawerOpen: PropTypes.bool,
};

NavSectionComponent.defaultProps = {
  label: '',
  icon: 'none',
  location: { pathname: '' },
  classes: { highlight: '' },
  children: null,
  drawerOpen: true,
};

export const NavItemStyled = withStyles(styles)(NavSectionComponent);
export default withRouter(withStyles(styles)(NavSectionComponent));
